let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3vJ23")).then(() => parcelRequire('3RuW3'));